import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ECalculateResultModalActionType {
  ModalOpened = 'calculateResultModal/opened',
  ModalClosed = 'calculateResultModal/closed',
}

export type TCalculateResultModalOpenedAction = ITypedReduxAction<ECalculateResultModalActionType.ModalOpened>;
export type TCalculateResultModalClosedAction = ITypedReduxAction<ECalculateResultModalActionType.ModalClosed>;

export type TCalculateResultModalActions = TCalculateResultModalOpenedAction | TCalculateResultModalClosedAction;
